import { z, type ZodSchema } from 'zod';

import { MotionServiceAttributesSchema } from '$lib/motion/motion-service-attributes';
import {
  isBuiltinDataManagementService,
  isBuiltinMotionService,
  isBuiltinNavigationService,
  isBuiltinVisionColorDetectorService,
  isBuiltinVisionMlModelService,
  isCartographerSLAMService,
} from '$lib/rdk';
import { DataManagementAttributesSchema } from '$lib/rdk/data-management';
import { isMlModelAPI } from '$lib/rdk/ml-model';
import type { APITriplet, ModelTriplet } from '$lib/resource-type';
import type { Attributes } from '$lib/robot-config';
import { CartographerSLAMServiceAttributesSchema } from '$lib/slam';

import { getMLModelFrameworkSchemaByService } from './ml-model-service';
import { NavigationServiceAttributesSchema } from './navigation-service';
import { VisionColorDetectorServiceSchema } from './vision-color-detector';
import { VisionMlModelAttributesSchema } from './vision-ml-model';

const BaseAttributesSchema = z.object({}).passthrough();

export const getServiceAttributesSchema = (
  api: APITriplet,
  model: ModelTriplet
): ZodSchema<Attributes> => {
  if (isBuiltinNavigationService(api, model)) {
    return NavigationServiceAttributesSchema;
  }
  if (isBuiltinVisionColorDetectorService(api, model)) {
    return VisionColorDetectorServiceSchema;
  }
  if (isBuiltinVisionMlModelService(api, model)) {
    return VisionMlModelAttributesSchema;
  }
  if (isMlModelAPI(api)) {
    return getMLModelFrameworkSchemaByService(model);
  }
  if (isBuiltinDataManagementService(api, model)) {
    return DataManagementAttributesSchema;
  }
  if (isCartographerSLAMService(api, model)) {
    return CartographerSLAMServiceAttributesSchema;
  }
  if (isBuiltinMotionService(api, model)) {
    return MotionServiceAttributesSchema;
  }

  return BaseAttributesSchema;
};
